module.exports = __webpack_public_path__ + "static/media/BungeeShade-Regular.ef898acb.ttf";